import { createRoute } from "@tanstack/react-router";
import { AuthGuard } from "@/components/auth/AuthGuard";
import { EmployeeCardView } from "@/pages/EmployeeCardView";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/employees/$employeeId",
  component: EmployeeCardRoute,
});

function EmployeeCardRoute() {
  const { employeeId } = Route.useParams();
  return (
    <AuthGuard>
      <EmployeeCardView employeeId={employeeId} />
    </AuthGuard>
  );
}
